// @flow

import { getApi } from './api.core'

export const get = ({ ukId }) => params =>
  getApi(`api/open_data/uk/${ukId}/building/`, params)
